import { render } from "./mobile-item.vue?vue&type=template&id=5c1d90ab&scoped=true&ts=true"
import script from "./mobile-item.vue?vue&type=script&lang=ts"
export * from "./mobile-item.vue?vue&type=script&lang=ts"

import "./mobile-item.vue?vue&type=style&index=0&id=5c1d90ab&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1d90ab"]])

export default __exports__